import type { ReactNode } from "react";
import { FollowZapExperimentalNavigation } from "./FollowZapExperimentalNavigation";

export function FollowZapExperimentalShell({
  ativo,
  className,
  integrado,
  ocultarHeader,
  header,
  mainClassName,
  children,
}: {
  ativo: boolean;
  className: string;
  integrado: boolean;
  ocultarHeader: boolean;
  header: ReactNode;
  mainClassName: string;
  children: ReactNode;
}) {
  return (
    <div
      data-followzap-experimental-shell={ativo ? "true" : undefined}
      data-followzap-shell={ativo ? "experimental" : undefined}
      data-user-header-shell={integrado ? "true" : undefined}
      className={className}
      style={{ backgroundColor: ativo ? "var(--fz-page-canvas-bg)" : undefined }}
    >
      <FollowZapExperimentalNavigation ativo={ativo} />
      <div className={ocultarHeader || ativo ? "lg:hidden" : ""}>{header}</div>
      <main data-followzap-experimental-content={ativo ? "true" : undefined} className={mainClassName}>
        {children}
      </main>
    </div>
  );
}
